module.exports = __webpack_public_path__ + "img/stamp2.bd501cad.jpg";